import { useEffect, useState } from "react";
import { ILive } from "../../helpers/types";
import { liveService } from "../../services";

const useFetchPublicProfileEvent = (creatorId: string) => {
  const [scheduledEvent, setScheduledEvent] = useState<ILive | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!creatorId) return;

    const fetchEvent = async () => {
      setLoading(true);
      setError(null);
      try {
        const event = await liveService.getCreatorPublicScheduleLive(creatorId);
        setScheduledEvent(event);
      } catch (err: any) {
        setError(err?.message || "Failed to fetch event");
        setScheduledEvent(null);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, [creatorId]);

  return { loading, error, scheduledEvent };
};

export default useFetchPublicProfileEvent;
